import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef
} from '@angular/core';
import { MonthViewDay } from '../../utils/month/MonthViewDay';
import { CalendarEvent } from '../../utils/CalendarEvent';

import * as dateFns from 'date-fns';
export class MonthCellComponent {
   day: MonthViewDay;

   openDay: MonthViewDay;

   locale: string;

   tooltipPlacement: string;

   tooltipAppendToBody: boolean;

   customTemplate: TemplateRef<any>;

   tooltipTemplate: TemplateRef<any>;

   highlightDay: EventEmitter<any> = new EventEmitter();

   unhighlightDay: EventEmitter<any> = new EventEmitter();

  
  eventClicked: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();
/**
 * @hidden
 * @param {?} mouseEvent
 * @param {?} calendarEvent
 * @return {?}
 */
onEventClick(mouseEvent: MouseEvent, calendarEvent: CalendarEvent): void {
    if (mouseEvent.stopPropagation) {
      mouseEvent.stopPropagation();
    }
    this.eventClicked.emit({ event: calendarEvent });
  }
/**
 * @param {?} end
 * @param {?} start
 * @return {?}
 */
isSameDay(end: Date, start: Date) {
    const /** @type {?} */ diff = dateFns.isSameDay(end, start);
    const /** @type {?} */ viewEnd = dateFns.endOfWeek(start);
    return diff;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-month-cell',
  template: `
    <ng-template
    #defaultTemplate
    let-day="day"
    let-openDay="openDay"
    let-locale="locale">
    <div class="cal-cell">
      <div class="cal-cell-top">
          <span class="cal-day-number">{{ day.date | date: 'dd' }}</span>
      </div>
      <span class="cal-day-badge" *ngIf="day.badgeTotal > 2">{{ day.badgeTotal - 2 }} more ...</span>
    </div>
    </ng-template>
    <ng-template
    [ngTemplateOutlet]="defaultTemplate"
    [ngTemplateOutletContext]="{
      day: day,
      openDay: openDay,
      locale: locale,
      highlightDay: highlightDay,
      unhighlightDay: unhighlightDay,
      eventClicked: eventClicked
    }">
    </ng-template>
  `,
  styles: [`
    .cal-cell {
        position: relative;
        height: 100%;
        overflow: hidden;
    }
    .cal-cell-top{
        z-index: 100;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: flex-start;
        height: 25%;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
    }

    .cal-day-badge {
        background-color: #e9e9e9;
        padding: 0 7px;
        font-size: 12px;
        color: rgb(121, 121, 121);
        white-space: nowrap;
        vertical-align: middle;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 18%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
    }
    .z-index-1000 {
        z-index: 1000;
    }
    .cal-day-number {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        font-size: 0.8em;
        margin-left: 5px;
        margin-right: 15px;
        margin-bottom: 10px;
        color: #555555;
    }
    @media (max-width: 576px) {
        .cal-day-number {
            font-size: 0.7em;
        }
    }
  `],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    class: 'cal-cell cal-day-cell',
    '[class.cal-past]': 'day.isPast',
    '[class.cal-today]': 'day.isToday',
    '[class.cal-future]': 'day.isFuture',
    '[class.cal-weekend]': 'day.isWeekend',
    '[class.cal-in-month]': 'day.inMonth',
    '[class.cal-out-month]': '!day.inMonth',
    '[class.cal-has-events]': 'day.events.length > 0',
    '[class.cal-open]': 'day === openDay',
    '[style.backgroundColor]': 'day.backgroundColor'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'day': [{ type: Input },],
'openDay': [{ type: Input },],
'locale': [{ type: Input },],
'tooltipPlacement': [{ type: Input },],
'tooltipAppendToBody': [{ type: Input },],
'customTemplate': [{ type: Input },],
'tooltipTemplate': [{ type: Input },],
'highlightDay': [{ type: Output },],
'unhighlightDay': [{ type: Output },],
'eventClicked': [{ type: Output },],
};
}

function MonthCellComponent_tsickle_Closure_declarations() {
/** @type {?} */
MonthCellComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MonthCellComponent.ctorParameters;
/** @type {?} */
MonthCellComponent.propDecorators;
/** @type {?} */
MonthCellComponent.prototype.day;
/** @type {?} */
MonthCellComponent.prototype.openDay;
/** @type {?} */
MonthCellComponent.prototype.locale;
/** @type {?} */
MonthCellComponent.prototype.tooltipPlacement;
/** @type {?} */
MonthCellComponent.prototype.tooltipAppendToBody;
/** @type {?} */
MonthCellComponent.prototype.customTemplate;
/** @type {?} */
MonthCellComponent.prototype.tooltipTemplate;
/** @type {?} */
MonthCellComponent.prototype.highlightDay;
/** @type {?} */
MonthCellComponent.prototype.unhighlightDay;
/** @type {?} */
MonthCellComponent.prototype.eventClicked;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
